export default __webpack_public_path__ + "static/media/error-circle-fill.b00f8d41.svg";